import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { ItemsService } from '../../../../services/items.service';
import { RenderedService } from '../../rendered.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getCountryCodesForSelect } from '@app/shared/country-codes';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['../../rendered.component.scss', './phone-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PhoneNumberComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Input() disabled: boolean;
  @Output() changed = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();

  cc = '+1';
  areaCode = '';
  subscriberNumber = '';
  e164Number = '';

  /** Avoid overwriting our fields when the parent echoes back our last emitted e164 (e.g. from parsing form state). */
  private lastEmittedE164 = '';

  countryCodes;
  constructor(
    public cdr: ChangeDetectorRef,
    private itemsService: ItemsService,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.update();

    this.itemsService
      .registerItem(this.info)
      .pipe(takeUntil(this.destroy$))
      .subscribe(d => {
        this.cdr.detectChanges();
      });
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  numberChanged() {
    let areaDigits = '';
    if (this.areaCode) {
      const cleaned = this.areaCode.replace(/\D/g, '');
      areaDigits = (cleaned.match(/\d/g) || []).join('');
      this.areaCode = areaDigits;
    }

    let subscriberDigits = '';
    if (this.subscriberNumber) {
      const cleaned = this.subscriberNumber.replace(/\D/g, '');
      subscriberDigits = (cleaned.match(/\d/g) || []).join('');
      this.subscriberNumber = subscriberDigits;
    }

    this.e164Number = this.cc + areaDigits + subscriberDigits;
    this.lastEmittedE164 = this.e164Number;

    this.changed.emit({
      value: {
        cc: this.cc,
        areaCode: this.areaCode,
        subscriberNumber: this.subscriberNumber,
        e164Number: this.e164Number,
      },
    });
  }

  update() {
    this.countryCodes = getCountryCodesForSelect('name');

    const incoming = this.value;
    const incomingE164 =
      incoming && typeof incoming === 'object' && !Array.isArray(incoming)
        ? String((incoming as any).e164Number ?? '')
        : typeof incoming === 'string'
          ? (incoming as string).trim()
          : '';
    if (incomingE164 && incomingE164 === this.lastEmittedE164) {
      this.cdr.detectChanges();
      return;
    }

    if (incoming && typeof incoming === 'object' && !Array.isArray(incoming)) {
      this.cc = (incoming as any).cc ?? '+1';
      this.areaCode = String((incoming as any).areaCode ?? '');
      this.subscriberNumber = String((incoming as any).subscriberNumber ?? '');
      this.e164Number = String((incoming as any).e164Number ?? '');
    } else if (typeof incoming === 'string' && (incoming as string).trim()) {
      this.cc = '+1';
      this.areaCode = '';
      this.subscriberNumber = (incoming as string).replace(/\D/g, '');
      this.e164Number = (incoming as string).trim();
    } else {
      this.cc = '+1';
      this.areaCode = '';
      this.subscriberNumber = '';
      this.e164Number = '';
    }
    this.cdr.detectChanges();
  }

}
